export const paymentKeys = {
    all: ['payment'] as const,
    options: (currencyCode: string) => [...paymentKeys.all, 'options', currencyCode] as const
} as const;

// Invalidations:
// none
